/**
 * Google AdSense do Super Vitrine: valores públicos da integração.
 *
 * Nada aqui é segredo. O ID do publisher e o ID do bloco vão para o HTML de
 * qualquer site que exibe AdSense; o Google os chama de código público.
 * Credencial, cookie e sessão da conta Google nunca entram no repositório.
 *
 * - client:   ID do publisher (conta AdSense), no formato do código de anúncio.
 * - slotGrade: bloco "Anuncios" (Display responsivo, criado na conta em
 *             2026-01-28 e reutilizado para a grade de ofertas da Home).
 * - intervaloGrade: um anúncio a cada N ofertas na grade. É a mesma cadência
 *             que o card de banner já usava.
 * - dominios: só nesses hosts o anúncio é pedido de verdade. Em localhost e em
 *             qualquer outro host o card mostra um espaço neutro e nenhuma
 *             requisição vai ao Google (evita tráfego inválido no desenvolvimento).
 *
 * A mesma lista de domínios e o mesmo client aparecem no loader de
 * public/index.html, que roda antes do React; um teste garante que não divergem.
 */
export const ADSENSE = {
    client: 'ca-pub-5849288102075292',
    slotGrade: '7434190624',
    intervaloGrade: 15,
    dominios: ['supervitrineofertas.com', 'www.supervitrineofertas.com'],
};

/** true só no domínio de produção. */
export const adsenseLiberado = () => typeof window !== 'undefined'
    && ADSENSE.dominios.includes(window.location.hostname);
